// extracted by css-extract-rspack-plugin
export default {"FixedSizeVirtualList":"RefsList-module__FixedSizeVirtualList__YEA5B"};